import initial from "../web-sh/src/store/initial";

export default {
  ...initial,
  auth: {
    ...initial.auth,
    userPm: null
  },
  payment: {
    plan: null,
    planLimit: {},
    planNoticeVisible: false
  },
  resource: {
    countries: [],
    plans: []
  },
  onboarding: {
    onboardingProcess: {},
    tutorialProcess: [],
    reloadOnboarding: false,
    welcomeVisible: false,
    welcomeBusinessVisible: false,
    showTutorial: false,
    getExtensionVisible: false,
    tutorialRunning: false,
    stepIndex: 0,
    tutorialDetailRunning: false,
    stepDetailIndex: 0,
  },
  enterprise: {
    ...initial.enterprise,
    enterpriseInvitations: []
  },
  privateEmail: {
    selectedAlias: null
  },
  permission: {
    showPremiumActions: true,
  }
}